﻿/* Country popup + selector (Shopify/Debutify safe)
   - First visit per tab (sessionStorage): show full-screen popup
   - After selection: show top-right flag button; desktop=dropdown, mobile=full popup
   - Hides before redirect so overlay never lingers
*/

(function () {
  var POPUP_ID = 'country-popup';
  var SWITCHER_ID = 'country-switcher';
  var DROPDOWN_ID = 'countryDropdown';
  var TOGGLE_ID = 'countryToggleBtn';

  // Country list (code → {label, flag})
  var COUNTRIES = {
    uae: { label: 'الإمارات العربية المتحدة', flag: '🇦🇪' },
    sa:  { label: 'السعودية',                 flag: '🇸🇦' },
    bh:  { label: 'البحرين',                  flag: '🇧🇭' },
    kw:  { label: 'الكويت',                   flag: '🇰🇼' },
    qa:  { label: 'قطر',                      flag: '🇶🇦' },
    om:  { label: 'عُمان',                    flag: '🇴🇲' },
    lb:  { label: 'لبنان',                    flag: '🇱🇧' },
    jo:  { label: 'الأردن',                   flag: '🇯🇴' },
    iq:  { label: 'العراق',                   flag: '🇮🇶' },
    eg:  { label: 'مصر',                      flag: '🇪🇬' },
    row: { label: 'باقي دول العالم',          flag: '🌍' }
  };
  var ORDER = ['uae','sa','bh','kw','qa','om','lb','jo','iq','eg','row'];

  function $(id) { return document.getElementById(id); }

  /* ---------- Animated show/hide ---------- */
  function showPopup() {
    var cover = document.getElementById('fg-cover');
    if (cover) cover.style.display = 'none';
    document.documentElement.classList.remove('fg-hide-body');
    document.documentElement.style.background = '';

    var popup = $(POPUP_ID);
    if (!popup) return;

    try { sessionStorage.setItem('fg_popup_shown', '1'); } catch(e) {}

    popup.style.display = 'flex';
    void popup.offsetWidth; // reflow for transition
    popup.classList.remove('is-closing');
    popup.classList.add('is-open');
    popup.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('popup-open');
    document.body.classList.add('popup-open');

    /* Show the close (X) button only when a country is already chosen
       (first-time visitors must pick one). */
    var hasCountry = false;
    try { hasCountry = !!localStorage.getItem('selectedCountry'); } catch (e) {}
    popup.classList.toggle('popup--closable', hasCountry);

    /* First visit only: detect where they are and offer to continue there. If a
       country is already saved they opened this to CHANGE it — never auto-move
       them off a deliberate choice. */
    if (!hasCountry) initDetected();
  }

  /* Exposed for the popup's close (X) button + the profile dropdown's "Change country" item */
  window.fgCloseCountryPopup = hidePopup;
  window.fgShowCountryPopup  = showPopup;

  function hidePopup() {
    var popup = $(POPUP_ID);
    if (!popup || popup.style.display === 'none') return;

    document.documentElement.classList.remove('fg-popup-ready');
    popup.classList.remove('is-open');
    popup.classList.add('is-closing');
    popup.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('popup-open');
    document.body.classList.remove('popup-open');

    var done = false;
    var finish = function () {
      if (done) return;
      done = true;
      popup.style.display = 'none';
      popup.removeEventListener('transitionend', finish);
    };
    popup.addEventListener('transitionend', finish, { once: true });
    setTimeout(finish, 350);
  }

  /* ---------- Show popup on first visit (no country selected, once per session) ---------- */
  /* OLD: only showed on non-country pages — kept for easy revert
  function showPopupIfNoCountry_OLD() {
    if (localStorage.getItem('selectedCountry')) return;
    var path = (location.pathname || '').toLowerCase();
    var host = (location.hostname || '').toLowerCase();
    if (
      path.includes('/pages/uae-collections') ||
      path.includes('/pages/lebanon') ||
      path.includes('/pages/jordan') ||
      path.includes('/pages/iraq') ||
      path.includes('/pages/egypt') ||
      path.includes('/collections/egypt') ||
      path.includes('/products/memo-x-flaregun') ||
      host.includes('flarenio.com')
    ) return;
    showPopup();
  }
  */
  /* ---------- Home page → country B-page redirect ----------
     Runs only on `/` (and `/ar/`). If a country is already saved, skip the
     old home page and go straight to that country's landing page.
     Uses location.replace() so the home page never appears in history.
  ----------------------------------------------------------------- */
  function redirectHomeToCountryPage() {
    /* Skip inside Shopify theme editor (iframe + designMode flag + admin host) */
    if (window.top !== window.self) return;
    if (window.Shopify && window.Shopify.designMode) return;

    var host = (location.hostname || '').toLowerCase();
    if (host.includes('flarenio.com')) return;
    if (host.indexOf('myshopify.com') !== -1) return;

    var path = (location.pathname || '');
    var isHome = (path === '/' || path === '/ar' || path === '/ar/');
    if (!isHome) return;

    var country = localStorage.getItem('selectedCountry');
    if (!country) return; // nothing saved → the popup/auto-route flow owns this visitor

    // Detect Arabic locale from URL
    var lp = (path.indexOf('/ar') === 0) ? '/ar' : '';

    var dest = null;
    switch (country) {
      case 'uae': dest = lp + '/pages/uae-b'; break;
      case 'lb':  dest = lp + '/pages/lebanon-collections';  break;
      case 'jo':  dest = lp + '/pages/jo-b';  break;
      case 'iq':  dest = lp + '/pages/iq-b'; break; /* Iraq's landing since 2026-10-10; the root home IS the worldwide store (readout item 18) */
      case 'eg':  dest = lp + '/pages/eg-b';  break;
      case 'bh':  dest = lp + '/pages/bh-b';       break;
      case 'kw':  dest = lp + '/pages/kw-b';       break;
      case 'qa':  dest = lp + '/pages/qa-b';       break;
      case 'om':  dest = lp + '/pages/om-b';       break;
      case 'sa':  dest = lp + '/pages/sa-b';       break;
      /* Worldwide visitors stay: "/" IS the worldwide store since 2026-10-10 (until
         then it was Iraq's landing, and they were sent to /pages/world-b). */
      case 'row': break;
    }
    if (dest) { window.__fgRedirecting = true; location.replace(dest); } // flag: fg-analytics must not record the dying page
  }

  /* A creator link-in-bio page is an ENTRY page the visitor tapped on purpose:
     page.creator-links, or one of its country copies page.creator-<country> (theme.liquid,
     2026-10-09). The template is the FULL name, so test the prefix. */
  function isCreatorPage() {
    return /^page\.creator-/.test(String((window.fgPage && window.fgPage.template) || ''));
  }

  function showPopupIfNoCountry() {
    /* Don't surface the country popup inside the theme editor */
    if (window.top !== window.self) return;
    if (window.Shopify && window.Shopify.designMode) return;
    /* Never on a creator page (owner 2026-10-02): a first visit opened the
       selector over the page, and the pick moved them to that country's store,
       so they never saw the creator they came for. The store asks if they go in.
       Their location is looked up while they read, so the head script on the
       page they tap into (theme.liquid, ?fgref=) reads it from the tab's cache. */
    if (isCreatorPage()) {
      try { if (!localStorage.getItem('selectedCountry')) detectCountry(function () {}); } catch (e) {}
      return;
    }
    /* The head geo auto-route is still deciding — it fires fg:georoute when it
       settles and the listener below re-runs this. Never open the selector on
       top of a redirect that's about to fire. */
    if (window.__fgGeoRoute === 'pending') return;
    var host = (location.hostname || '').toLowerCase();
    if (host.includes('flarenio.com')) return;
    if (host.indexOf('myshopify.com') !== -1) return;
    if (localStorage.getItem('selectedCountry')) return;
    var path = (location.pathname || '').replace(/\/$/, '') || '/';
    var isHome = (path === '/');
    if (!isHome) {
      try { if (sessionStorage.getItem('fg_popup_shown')) return; } catch(e) {}
    }
    showPopup();
  }

  /* ---------- noon countries (dynamic — edit HERE as stores move to/from noon) ----------
     These exist only on noon, not on this site. Choosing one never persists,
     and returning to the site (back button from noon/WhatsApp) re-opens the
     region selector instead of rendering a store that doesn't exist.
     Site countries (iq/lb/jo/eg/…) are simply everything NOT in this list. */
  /* UAE is a SITE country again (owner 2026-07-11: "the theme is better now, let
     the uae option go to our theme") — full Lebanon-anchored storefront:
     header/nav, brands, day/night, noon-parity prices/reviews, Buy-on-noon PDPs. */
  var NOON_COUNTRIES = {}; /* all GCC are SITE countries — qa 2026-07-21; bh/kw/om go-live 2026-07-22 */

  /* Back/forward-cache restore (back button from noon, WhatsApp, any external
     site). The country gate doesn't re-run on a restored page, so decide here:
     - a SITE country is selected → normal page; just clear the stale redirect loader.
     - noon pick / nothing selected → never reveal the site: keep the loader
       covering the screen and reload with the popup session-flag cleared, so
       the country selector shows again on any page. */
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    var country = null;
    try { country = localStorage.getItem('selectedCountry'); } catch (err) {}
    if ((country && !NOON_COUNTRIES[country]) || isCreatorPage()) { // a creator page never asks
      var stale = document.getElementById('fg-choose-loader');
      if (stale) stale.remove();
      return;
    }
    showRedirectLoader();
    try { sessionStorage.removeItem('fg_popup_shown'); } catch (err) {}
    window.location.reload();
  });

  /* ---------- Auto-detect the visitor's country (IP → panel /api/geo) --------
     The storefront can't see the visitor's IP country, so the panel (on Vercel,
     which resolves it at the edge) answers /api/geo. Without this, every NEW
     visitor simply stayed on "/" — Iraq's home until 2026-10-10, the worldwide store
     since — until they picked a country here, so Lebanese/Egyptian shoppers were browsing the Iraq store
     (owner 2026-07-15; confirmed in the Live View data).
     We announce the detected country at the TOP of the selector and continue
     there after a short countdown. Choosing any country cancels the countdown,
     so the timer can never redirect on top of a deliberate choice. */
  var GEO_ENDPOINT  = 'https://admin.flareguntv.com/api/geo';
  var GEO_CACHE_KEY = 'fg_geo_country';
  var GEO_TO_CODE   = { LB: 'lb', AE: 'uae', SA: 'sa', IQ: 'iq', JO: 'jo', EG: 'eg', BH: 'bh', KW: 'kw', QA: 'qa', OM: 'om' };
  var EN_NAMES      = { uae: 'the UAE', sa: 'Saudi Arabia', bh: 'Bahrain', kw: 'Kuwait', qa: 'Qatar', om: 'Oman', lb: 'Lebanon', jo: 'Jordan', iq: 'Iraq', eg: 'Egypt', row: 'Worldwide' };
  var AUTO_SECONDS  = 3;

  function isAr() {
    try {
      if (window.FG_LANG && typeof FG_LANG.get === 'function') return FG_LANG.get() === 'ar';
      return (localStorage.getItem('fg_lang') || 'en') === 'ar';
    } catch (e) { return false; }
  }

  /* Asked once per tab and cached — never on every popup open. */
  function detectCountry(cb) {
    /* Test override (?fggeo=LB, set by the head script) — lets us preview the
       banner for any country from anywhere. Never set for real visitors. */
    var forced = null;
    try { forced = sessionStorage.getItem('fg_geo_force'); } catch (e) {}
    if (forced) { cb(forced); return; }

    var cached = null;
    try { cached = sessionStorage.getItem(GEO_CACHE_KEY); } catch (e) {}
    if (cached) { cb(cached === '-' ? null : cached); return; }
    try {
      fetch(GEO_ENDPOINT, { credentials: 'omit' })
        .then(function (r) { return r.json(); })
        .then(function (j) {
          var c = (j && j.country) ? String(j.country).toUpperCase() : null;
          try { sessionStorage.setItem(GEO_CACHE_KEY, c || '-'); } catch (e) {}
          cb(c);
        })
        .catch(function () { cb(null); });
    } catch (e) { cb(null); }
  }

  function initDetected() {
    var box = document.querySelector('[data-fg-detected]');
    if (!box || box.getAttribute('data-fg-init')) return;
    detectCountry(function (iso) {
      if (!iso) return;
      var code = GEO_TO_CODE[iso];
      var info = code && COUNTRIES[code];
      if (!info) return;                 /* no store for that country → let them choose */
      box.setAttribute('data-fg-init', '1');

      var ar     = isAr();
      var name   = ar ? info.label : (EN_NAMES[code] || info.label);
      var isNoon = !!NOON_COUNTRIES[code];
      var go     = box.querySelector('[data-fg-detected-go]');
      var cancel = box.querySelector('[data-fg-detected-cancel]');
      var goText = ar ? ('تابع إلى ' + name) : ('Continue to ' + name);
      var timer  = null;

      /* The label lives in its own span so the countdown fill can sweep BEHIND
         it (the fill is the button's ::before). */
      go.innerHTML = '';
      var goLbl = document.createElement('span');
      goLbl.className = 'country-btn__lbl';
      go.appendChild(goLbl);
      function setLbl(t) { goLbl.textContent = t; }

      function stop() {
        if (timer) { clearInterval(timer); timer = null; }
        go.classList.remove('is-counting');   /* fill snaps back to empty */
        setLbl(goText);
      }

      box.querySelector('[data-fg-detected-flag]').textContent  = info.flag;
      box.querySelector('[data-fg-detected-title]').textContent = ar ? ('أنت في ' + name) : ("You're in " + name);
      box.querySelector('[data-fg-detected-sub]').textContent   = isNoon
        ? (ar ? ('طلبات ' + name + ' بتتم عبر نون') : ('Orders for ' + name + ' are served on noon'))
        : (ar ? ('رح نفرجيك متجر ' + name) : ("We'll show you the " + name + ' store'));
      var choice = box.parentNode;   /* .country-choice */
      cancel.textContent = ar ? 'اختر دولة تانية ▾' : 'Choose another country ▾';
      setLbl(goText);
      box.hidden = false;
      /* Lead with this prompt ALONE — don't also dump the whole list on someone
         we've just told we know where they are. The list is one tap away. */
      if (choice) choice.classList.add('fg-detected-only');

      go.addEventListener('click', function () { stop(); window.chooseCountry(code); });
      /* The escape hatch: stop the countdown and reveal the real selector. */
      cancel.addEventListener('click', function () {
        stop();
        if (choice) choice.classList.remove('fg-detected-only');
        cancel.hidden = true;                     /* it has done its job */
      });
      /* Picking ANY country in the revealed list also cancels the countdown, so
         the timer can never redirect on top of a deliberate choice. */
      if (choice) {
        choice.addEventListener('click', function (e) {
          var t = e.target;
          if (t && t.closest && t.closest('.country-btn') && !t.closest('[data-fg-detected-go]')) stop();
        }, true);
      }

      /* noon countries leave the site — never yank someone off-site on a timer. */
      if (isNoon) return;

      var left = AUTO_SECONDS;
      setLbl(goText + ' (' + left + ')');
      /* Sweep the fill across the button for exactly the countdown. rAF so the
         browser paints scaleX(0) first — otherwise the transition is skipped. */
      go.style.setProperty('--fg-cd', AUTO_SECONDS + 's');
      requestAnimationFrame(function () { go.classList.add('is-counting'); });
      timer = setInterval(function () {
        left--;
        if (left <= 0) {
          /* Don't stop() here — that would snap the fill back to empty a frame
             before we leave. Let it stay full; the redirect loader takes over. */
          clearInterval(timer); timer = null;
          window.chooseCountry(code);
          return;
        }
        setLbl(goText + ' (' + left + ')');
      }, 1000);
    });
  }

  /* ---------- Public chooseCountry ---------- */

  // Cover the screen with the branded page loader during the redirect so the
  // shopper sees the loading animation instead of the site (or a wrong-country
  // flash) between choosing a country and landing on the destination.
  function showRedirectLoader() {
    if (document.getElementById('fg-choose-loader')) return;
    var el = document.createElement('div');
    el.id = 'fg-choose-loader';
    el.className = 'fg-page-loader';           // reuses the loader styles (logo + day/night bg)
    el.setAttribute('role', 'status');
    el.setAttribute('aria-label', 'Loading');
    el.style.zIndex = '2147483647';            // above the country popup
    el.innerHTML = '<span class="fg-page-loader__logo" aria-hidden="true"></span>';
    document.body.appendChild(el);
  }

  window.chooseCountry = function (country) {
    if (NOON_COUNTRIES[country]) {
      // noon country → clear any previously-chosen country so the site renders
      // nothing for it, and clear the popup session-flag so the region selector
      // reappears on ANY page if the shopper comes back (not just the home).
      try { localStorage.removeItem('selectedCountry'); } catch (e) {}
      try { sessionStorage.removeItem('fg_popup_shown'); } catch (e) {}
    } else {
      try { localStorage.setItem('selectedCountry', country); } catch (e) {}
    }
    showRedirectLoader();

    // Trigger closing animation; redirect fires after all transitions finish
    var popup = document.getElementById('country-popup');
    if (popup) {
      document.documentElement.classList.remove('fg-popup-ready');
      popup.classList.remove('is-open');
      popup.classList.add('is-closing');
      popup.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('popup-open');
      document.body.classList.remove('popup-open');
    }

    mountSwitcher();
    updateCartVisibility();
    applyCountryNav();

    setTimeout(function () {
      if (popup) popup.style.display = 'none';
      var lp = (window.FG_LANG && window.FG_LANG.get() === 'ar') ? '/ar' : '';
      if (!lp && window.__fgABLang && window.__fgABLang(country) === 'ar') lp = '/ar'; // A/B ar-arm default
      switch (country) {
        case 'uae':
          /* UAE stays on-site: uae-b landing; purchases complete on noon via the
             per-product deep-link buttons. */
          window.location.href = lp + '/pages/uae-b'; break;
        case 'bh':
          window.location.href = lp + '/pages/bh-b'; break;
        case 'kw':
          window.location.href = lp + '/pages/kw-b'; break;
        case 'qa':
          window.location.href = lp + '/pages/qa-b'; break;
        case 'om':
          window.location.href = lp + '/pages/om-b'; break;
        case 'sa':
          window.location.href = lp + '/pages/sa-b'; break;
        case 'lb':
          window.location.href = lp + '/pages/lebanon-collections'; break;
        case 'jo':
          /* jo-b is Jordan's landing (matches the gates + الرئيسية nav). */
          window.location.href = lp + '/pages/jo-b'; break;
        case 'iq':
          /* Iraq's landing is /pages/iq-b since 2026-10-10 (the root home is the worldwide store). */
          window.location.href = lp + '/pages/iq-b'; break;
        case 'eg':
          /* eg-b is Egypt's landing (was deep-linking a single product). */
          window.location.href = lp + '/pages/eg-b'; break;
        case 'row':
        default:
          /* Rest of world → the deduped WORLD catalog (every product once,
             owner 2026-07-11); orders go through the WhatsApp cart. Its landing IS
             the root home since 2026-10-10 (it was /pages/world-b). */
          window.location.href = lp + '/'; break;
      }
    }, 900);
  };

  /* ---------- Build country dropdown list HTML (shared) ---------- */
  function buildDropdownHTML() {
    var html = '';
    ORDER.forEach(function (code) {
      var item  = COUNTRIES[code];
      var label = (window.FG_LANG && typeof window.FG_LANG.countryLabel === 'function')
        ? window.FG_LANG.countryLabel(code)
        : item.label;
      html += '<button class="drop-btn" data-code="'+ code +'">' + item.flag + ' ' + label + '</button>';
    });
    return html;
  }

  /* ---------- Inline nav switcher ("Delivery to ...") for Iraq pages ---------- */
  function mountNavSwitcher(desktopMount, mobileMount) {
    var selected = (localStorage.getItem('selectedCountry') || 'row');
    var country  = COUNTRIES[selected] || COUNTRIES.row;
    var flag     = country.flag;
    var label    = (window.FG_LANG && typeof window.FG_LANG.countryLabel === 'function')
      ? window.FG_LANG.countryLabel(selected)
      : country.label;
    var deliverTo = (window.FG_LANG && FG_LANG.get && FG_LANG.get() === 'ar') ? 'التوصيل إلى' : 'Delivery to';

    var btnHTML =
      '<button class="fg-country-btn" type="button" aria-label="Select country">' +
        '<span class="fg-country-btn__label">' + deliverTo + '</span>' +
        '<span class="fg-country-btn__flag">' + flag + '</span>' +
        '<span class="fg-country-btn__name">' + label + '</span>' +
        '<span class="fg-country-btn__chev" aria-hidden="true">▾</span>' +
      '</button>';

    function wire(container, withDropdown) {
      var btn = container.querySelector('.fg-country-btn');
      var dd  = container.querySelector('.fg-country-dropdown');
      if (!btn) return;
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        if (!withDropdown || window.innerWidth <= 768) {
          showPopup();
        } else if (dd) {
          dd.style.display = (dd.style.display === 'block') ? 'none' : 'block';
        }
      });
      if (dd) {
        dd.addEventListener('click', function (e) {
          var b = e.target.closest('.drop-btn');
          if (!b) return;
          dd.style.display = 'none';
          window.chooseCountry(b.getAttribute('data-code'));
        });
        document.addEventListener('click', function (e) {
          if (!container.contains(e.target)) dd.style.display = 'none';
        }, { passive: true });
      }
    }

    if (desktopMount && !desktopMount.querySelector('.fg-country-btn')) {
      desktopMount.innerHTML = btnHTML + '<div class="fg-country-dropdown" style="display:none;">' + buildDropdownHTML() + '</div>';
      wire(desktopMount, true);
    }
    if (mobileMount && !mobileMount.querySelector('.fg-country-btn')) {
      mobileMount.innerHTML = btnHTML; // mobile opens full popup
      wire(mobileMount, false);
    }

    // Remove the floating top-right switcher if it exists (relocated into nav)
    var fixed = $(SWITCHER_ID);
    if (fixed) fixed.style.display = 'none';
  }

  /* ---------- Top-right selector ---------- */
  function mountSwitcher() {
    // Iraq pages: render inline in the nav instead of the floating top-right chip
    var navDesktop = document.getElementById('fg-country-mount-desktop');
    var navMobile  = document.getElementById('fg-country-mount-mobile');
    if (navDesktop || navMobile) {
      mountNavSwitcher(navDesktop, navMobile);
      return;
    }

    var selected = (localStorage.getItem('selectedCountry') || 'row');
    var flag = (COUNTRIES[selected] && COUNTRIES[selected].flag) || '🌍';

    var switcher = $(SWITCHER_ID);
    if (!switcher) {
      switcher = document.createElement('div');
      switcher.id = SWITCHER_ID;
      switcher.style.position = 'fixed';
      switcher.style.top = '10px';
      switcher.style.right = '10px';
      switcher.style.zIndex = '9999';
      document.body.appendChild(switcher);
    }

    switcher.innerHTML =
      '<button id="' + TOGGLE_ID + '" style="background:#eee;border:0;padding:8px 12px;border-radius:8px;font-weight:700;cursor:pointer;">' +
        flag +
      '</button>' +
      '<div id="' + DROPDOWN_ID + '" style="display:none;position:absolute;top:42px;right:0;background:#fff;border:1px solid #ddd;border-radius:8px;box-shadow:0 10px 30px rgba(0,0,0,.15);min-width:220px;overflow:hidden;"></div>';

    var toggle = $(TOGGLE_ID);
    var dropdown = $(DROPDOWN_ID);

    // Build dropdown items
    var html = '';
    ORDER.forEach(function (code) {
      var item  = COUNTRIES[code];
      var label = (window.FG_LANG && typeof window.FG_LANG.countryLabel === 'function')
        ? window.FG_LANG.countryLabel(code)
        : item.label;
      html += '<button class="drop-btn" data-code="'+ code +'" style="display:block;width:100%;padding:10px 12px;border:0;background:#fff;text-align:right;cursor:pointer;">' +
              item.flag + ' ' + label +
              '</button>';
    });
    dropdown.innerHTML = html;

    // Toggle: mobile opens full popup; desktop toggles dropdown
    toggle.addEventListener('click', function () {
      if (window.innerWidth <= 768) {
        showPopup(); // full popup on mobile
      } else {
        dropdown.style.display = (dropdown.style.display === 'block') ? 'none' : 'block';
      }
    });

    // Pick from dropdown
    dropdown.addEventListener('click', function (e) {
      var btn = e.target.closest('.drop-btn');
      if (!btn) return;
      dropdown.style.display = 'none';
      window.chooseCountry(btn.getAttribute('data-code'));
    });

    // Close dropdown on outside click
    document.addEventListener('click', function (e) {
      if (!switcher.contains(e.target)) dropdown.style.display = 'none';
    }, { passive: true });
  }

  /* ---------- Cart visibility (UAE only) ---------- */
  function updateCartVisibility() {
    /* UAE buys on noon only (2026-07-11) — no country uses the Shopify cart now,
       so the cart icon is hidden for everyone. Restore the uae check if the
       real cart ever comes back. */
    var cart = document.getElementById('cart-icon-bubble');
    if (!cart) return;
    cart.style.display = 'none';
  }

  /* ---------- Country nav ----------
     Pulls from window.FG_NAV_ITEMS (manual blocks, Arabic labels, controlled order)
     and window.FG_NAV_ITEMS_AUTO (collections tagged country:XX — fully automatic).
     Manual items show first; tagged collections not already listed append at the end.
     Add a new collection → tag it "country:lb" in Shopify admin → it auto-appears.
     OR: Customize → Header → Country Nav Config → Add Nav Item block for custom label.
  --------------------------------------------------------- */
  // B landing page (الرئيسية) per country
  var COUNTRY_HOME_PAGES = {
    uae: '/pages/uae-b',
    sa:  '/pages/sa-b',
    lb:  '/pages/lebanon-collections', // Iraq-style home (the old /pages/lb-b is retired)
    jo:  '/pages/jo-b',
    iq:  '/pages/iq-b', // Iraq's landing since 2026-10-10 (it was the root home)
    eg:  '/pages/eg-b',
    qa:  '/pages/qa-b',
    bh:  '/pages/bh-b',
    kw:  '/pages/kw-b',
    om:  '/pages/om-b',
    row: '/' // rest-of-world landing: the root home since 2026-10-10 (it was /pages/world-b)
  };

  // Collections list page (مجموعات) per country
  var COUNTRY_COLLECTION_PAGES = {
    uae: '/pages/uae-collections',
    sa:  '/pages/sa-b',
    lb:  '/pages/lebanon-collections',
    jo:  '/pages/jordan-collections',
    iq:  '/pages/iraq-collections',
    eg:  '/pages/egypt-collections', // was /pages/egypt — that page doesn't exist (404)
    qa:  '/pages/qa-b',
    bh:  '/pages/bh-b',
    kw:  '/pages/kw-b',
    om:  '/pages/om-b'
  };

  var _origDesktopNav = null;
  var _origMobileNav  = null;

  function applyCountryNav() {
    var selected  = localStorage.getItem('selectedCountry');
    /* No usable saved country (nothing, row, or a noon country like uae that
       never persists) → fall back to the PAGE's own country so uae/jo/eg pages
       reached directly (Google, links) still get their category nav. */
    if ((!selected || selected === 'row' || NOON_COUNTRIES[selected]) && window.FG_PAGE_COUNTRY) {
      selected = window.FG_PAGE_COUNTRY;
    }
    var desktopUl = document.querySelector('nav.header__inline-menu ul.list-menu--inline');
    var mobileUl  = document.querySelector('nav.menu-drawer__navigation ul.menu-drawer__menu');

    // Save fresh server-rendered originals on each init (called on page:load)
    if (desktopUl) _origDesktopNav = desktopUl.innerHTML;
    if (mobileUl)  _origMobileNav  = mobileUl.innerHTML;

    var fp = document.getElementById('fg-nav-fp');
    if (!selected || selected === 'row') { if (fp) fp.parentNode.removeChild(fp); return; }

    var manual = (window.FG_NAV_ITEMS      || []).filter(function (i) { return i.c === selected; });
    var auto   = (window.FG_NAV_ITEMS_AUTO || []).filter(function (i) { return i.c === selected; });

    // Merge: manual first, then auto items not already listed
    var manualUrls = manual.map(function (i) { return i.u; });
    var extra = auto.filter(function (a) { return manualUrls.indexOf(a.u) === -1; });
    var items = manual.concat(extra);

    // Prepend fixed items: الرئيسية → B landing page, مجموعات → collections list
    var pinned = [];
    if (COUNTRY_HOME_PAGES[selected]) {
      pinned.push({ l: 'الرئيسية', l_ar: 'المتجر', u: COUNTRY_HOME_PAGES[selected] });
    }
    if (COUNTRY_COLLECTION_PAGES[selected]) {
      pinned.push({ l: 'مجموعات', u: COUNTRY_COLLECTION_PAGES[selected] });
    }

    // Remove duplicates: strip any item whose URL or Arabic label matches a pinned entry
    var pinnedUrls = pinned.map(function (p) { return p.u; });
    items = items.filter(function (i) {
      return i.l !== 'الرئيسية' && i.l !== 'مجموعات' && pinnedUrls.indexOf(i.u) === -1;
    });
    items = pinned.concat(items);

    if (!items.length) { if (fp) fp.parentNode.removeChild(fp); return; }

    // Preserve current locale prefix so language doesn't reset on nav click
    var lp = (window.Shopify && window.Shopify.locale && window.Shopify.locale !== 'en')
      ? '/' + window.Shopify.locale : '';
    var isAr = (window.Shopify && window.Shopify.locale === 'ar')
      || /[?&](lang|locale)=ar(&|$)/.test(location.search)
      || /\/ar\//.test(location.pathname);

    var NAV_AR = {
      'Home': 'الرئيسية', 'Collections': 'مجموعات',
      'Offers': 'العروض', 'Fan Coolers': 'مراوح تبريد', 'Cooling Fans': 'مراوح التبريد',
      'Headsets': 'سماعات', 'Triggers': 'شفتات', 'Accessories': 'إكسسوار',
      'Sleeves': 'أكمام',
      'Adapters': 'محولات', 'Chargers': 'شواحن'
    };

    function navLabel(item) {
      var langIsAr = (window.FG_LANG && typeof window.FG_LANG.get === 'function')
        ? window.FG_LANG.get() === 'ar' : isAr;
      if (langIsAr) {
        if (item.l_ar) return item.l_ar;
        if (NAV_AR[item.l]) return NAV_AR[item.l];
      }
      if (window.FG_LANG && typeof window.FG_LANG.navLabel === 'function')
        return window.FG_LANG.navLabel(item.l, item.u);
      return item.l;
    }

    if (desktopUl) {
      desktopUl.innerHTML = items.map(function (item) {
        return '<li><a href="' + lp + item.u + '" class="header__menu-item list-menu__item link link--text focus-inset mega-menu--item-first">' + navLabel(item) + '</a></li>';
      }).join('');
    }
    if (mobileUl) {
      mobileUl.innerHTML = items.map(function (item) {
        return '<li><a href="' + lp + item.u + '" class="menu-drawer__menu-item list-menu__item link link--text focus-inset">' + navLabel(item) + '</a></li>';
      }).join('');
    }
    if (fp) fp.parentNode.removeChild(fp);
  }

  /* ---------- Auto-route arrival toast ----------
     The head geo script just moved a first-time visitor to their country's
     store without asking (the selector was losing over half of them — tracker
     research 2026-08-15). Tell them where they landed and hand them the escape
     hatch; the country is already saved, so the popup opens closable. Shows
     once per auto-route (the session flag is consumed on render). */
  function maybeShowAutoRouteToast() {
    var code = null;
    try { code = sessionStorage.getItem('fg_autoroute'); } catch (e) {}
    if (!code) return;
    try { sessionStorage.removeItem('fg_autoroute'); } catch (e) {}
    var info = COUNTRIES[code];
    if (!info || document.getElementById('fg-autoroute-toast')) return;

    if (window.fgTrack) window.fgTrack({ type: 'autoroute', label: code, path: (location.pathname || '').slice(0, 200) });

    var ar    = isAr();
    var name  = ar ? info.label : (EN_NAMES[code] || info.label);
    /* EN titles start mid-sentence for uae ("the UAE") — capitalize for the bold line */
    var title = ar ? ('متجر ' + name) : (name.charAt(0).toUpperCase() + name.slice(1) + ' store');
    var sub   = ar ? ('الأسعار والتوصيل إلى ' + name) : ('Prices &amp; delivery for ' + name);
    /* Worldwide has no local delivery promise yet (owner + partner still
       deciding) — say what IS true: the full catalogue, ordered on WhatsApp. */
    if (code === 'row') {
      title = ar ? 'المتجر العالمي' : 'Worldwide store';
      sub   = ar ? 'كل منتجاتنا — الطلب عبر واتساب' : 'Our full catalogue — order on WhatsApp';
    }
    var el = document.createElement('div');
    el.id = 'fg-autoroute-toast';
    el.setAttribute('role', 'status');
    el.innerHTML =
      '<span class="fg-artoast__flag" aria-hidden="true">' + info.flag + '</span>' +
      '<span class="fg-artoast__txt">' +
        '<b class="fg-artoast__title">' + title + '</b>' +
        '<span class="fg-artoast__sub">' + sub + '</span>' +
      '</span>' +
      /* data-track keeps the analytics label stable across EN/AR button text */
      '<button type="button" class="fg-artoast__btn" data-track="fg-autoroute-change">' + (ar ? 'تغيير الدولة' : 'Change country') + '</button>';
    document.body.appendChild(el);
    requestAnimationFrame(function () { el.classList.add('is-in'); });

    var gone = false;
    function dismiss() {
      if (gone) return;
      gone = true;
      el.classList.remove('is-in');
      setTimeout(function () { if (el.parentNode) el.parentNode.removeChild(el); }, 400);
    }
    el.querySelector('.fg-artoast__btn').addEventListener('click', function () {
      dismiss();
      showPopup(); // country already saved → selector opens with the X available
    });
    setTimeout(dismiss, 3000); /* owner 2026-08-15: 3s is enough — Change-country stays reachable via the header selector */
  }

  /* ---------- Wrong-store nudge ----------
     Owner 2026-08-27: "let the message come through to ALL users that they are
     on the wrong store" — the old version compared geo against the SAVED
     country and required one to exist, so the biggest wrong-store bucket
     (visitors with nothing saved, browsing a store that isn't theirs — 14
     Lebanese sessions on Iraq's "/" in 11 days) never saw it, and its 12s
     auto-dismiss converted 1 of 16 shows. Now:
       · compares geo against the STORE THE PAGE BELONGS TO
         (window.fgPage.country, resolved server-side; neutral pages like
         404/cart fall back to the saved country),
       · no saved-country requirement,
       · PERSISTENT — re-appears on every page until the visitor switches or
         dismisses (✕ silences it for the session). One analytics row per
         session regardless of how many pages it rides.

     Owner 2026-08-27, second pass: "if we know the user is on the wrong
     website, why don't we land him straight on the right country?" — so on a
     STORE page (landing, collection, home) we now MOVE them instead of asking,
     landing on their own store with the existing arrival toast ("… store /
     Change country"), the same escape hatch the first-visit auto-route uses.
     Two deliberate limits, both about not losing the sale:
       · a PRODUCT page is never hijacked — a shopper who tapped a specific
         product from Instagram/WhatsApp came for THAT product, and their own
         store may not carry it (Egypt has one product); moving them there
         drops what they clicked. They get the bar instead.
       · we move a browser ONCE (localStorage fg_geo_moved). Geo can be wrong
         (VPN, roaming, an expat buying for family), so if they come back to a
         store we moved them off, that is a decision — never bounce them again.
     Fires only when the geo country HAS a store of its own. */
  /* ---------------------------------------------------------------------
     The product link came from ANOTHER country's store (owner 2026-09-08:
     "if I am in UAE and my friend sends me a link from Lebanon, if that
     product exists in UAE we should switch it to the UAE product; if it
     doesn't, say this product is in a different country and does not exist
     in yours"). Measured that day: 104 of 269 product views in 48h were on a
     store that did not match the visitor, and 5 of 16 WhatsApp orders came
     off one — a UAE customer ordering an Iraqi product in dinars.

     Data comes from snippets/fg-twin-data.liquid (window.fgTwins); the country
     vocabulary, the geo lookup and the bar styling are the ones already in
     this file. Their SAVED country wins over geo — an expat buying for family
     chose that store on purpose. `next` runs the ordinary wrong-store nudge
     when there is nothing to do here.
     --------------------------------------------------------------------- */
  /* The language of the PAGE, not of the toggle. isAr() reads FG_LANG (the A/B
     arm), which can say Arabic while the page rendered English — that put an
     Arabic bar on an English product page in testing. fgTwins.lp is the locale
     Liquid actually rendered ( '' or '/ar' ). */
  function twinAr() {
    try {
      if (window.fgTwins && window.fgTwins.lp === '/ar') return true;
      return (document.documentElement.getAttribute('lang') || '').toLowerCase().indexOf('ar') === 0;
    } catch (e) { return false; }
  }
  function maybeSwitchProductCountry(rawNext) {
    var tw = window.fgTwins;
    /* The entry pageview is HELD while this decides, the same handshake the
       first-visit geo route uses (__fgGeoRoute / fg:georoute). fg-twin-data sets
       __fgTwinRoute='pending' in the HEAD — it has to be the head, because
       fg-analytics renders inline in <body> and beacons synchronously at parse
       time, long before this file's DOMContentLoaded work runs. Without the hold
       the switch set __fgRedirecting too late to matter: the wrong-country view
       was already sent, the destination sent a second one, and "104 of 269
       product views were on the wrong store" — the number this whole feature was
       built to move — could never fall however well the switch worked.
       Every terminal path must resolve, or the pageview is lost instead of
       delayed: next() resolves 'stay' for all of them, and the two paths that
       keep the shopper here without calling next() resolve it themselves. */
    var twinSettled = false;
    function twinVerdict(state) {
      if (twinSettled) return;
      twinSettled = true;
      window.__fgTwinRoute = state;
      try { document.dispatchEvent(new CustomEvent('fg:twinroute', { detail: state })); } catch (e) {}
    }
    function next() { twinVerdict('stay'); return rawNext(); }
    if (!tw || !tw.cc) return next();                    // not a product page
    try {
      if (window.top !== window.self) return next();
      if (window.Shopify && window.Shopify.designMode) return next();
      var host = (location.hostname || '').toLowerCase();
      if (host.indexOf('myshopify.com') !== -1 || host.indexOf('flarenio.com') !== -1) return next();
      if (window.__fgRedirecting) return next();
      /* A creator link's location lookup (theme.liquid, ?fgref=) is still choosing
         their store: decide once it has (2026-10-02). It saves their country and
         stays, so this runs again with the right one. */
      if (window.__fgGeoRoute === 'pending') {
        document.addEventListener('fg:georoute', function (e) {
          if (e && e.detail === 'routed') return next();
          maybeSwitchProductCountry(rawNext);
        }, { once: true });
        return;
      }
      /* ?fgtwin=0 — the "see it anyway" link back, and the QA/support escape. */
      if (/[?&]fgtwin=0/.test(location.search)) { rememberKeep(); return next(); }
      var keep = null;
      try { keep = sessionStorage.getItem('fg_twin_keep:' + tw.handle); } catch (e) {}
      if (keep) return next();                           // they asked to stay
      /* Hard stop against ping-pong: if a twin's own country: tag ever
         disagreed with the map, two pages could hand the shopper back and
         forth. One hop is all this feature ever needs. */
      var hops = 0;
      try { hops = parseInt(sessionStorage.getItem('fg_twin_hops') || '0', 10) || 0; } catch (e) {}
      if (hops >= 1) return next();
      var saved = null;
      try { saved = localStorage.getItem('selectedCountry'); } catch (e) {}
      if (saved) return decide(saved, false);
      detectCountry(function (iso) {
        if (!iso) return next();          // geo FAILED — never act on silence
        var cc = GEO_TO_CODE[String(iso).toUpperCase()] || 'row';  // a real answer, no store there
        decide(cc, true);
      });
    } catch (e) { return next(); }

    function rememberKeep() { try { sessionStorage.setItem('fg_twin_keep:' + tw.handle, '1'); } catch (e) {} }

    function decide(mine, fromGeo) {
      if (!mine || mine === tw.cc) return next();      // already the right store
      /* Worldwide: nothing to switch to, and we never save 'row' here — that is
         what turns the price OFF via fg-row-price-gate. Label it instead. */
      if (mine === 'row') return labelPrice();
      /* No map on the page at all — the metafield is blank (the documented
         off-switch) or the nightly rebuild has not run. We know nothing, so we
         say nothing; claiming "not sold in your country" store-wide off a
         missing file is the worst thing this feature could do. `has` is what
         separates that from a product the map legitimately does not list. */
      if (!tw.has) return next();
      var twin = tw.map && tw.map[mine];
      if (twin) {
        /* Their country is now a fact about this browser, so the rest of the
           site stops guessing too — but never overwrite a choice they made. */
        if (fromGeo) { try { localStorage.setItem('selectedCountry', mine); } catch (e) {} }
        try { sessionStorage.setItem('fg_twin_from', tw.cc + '|' + tw.handle); } catch (e) {}
        try { sessionStorage.setItem('fg_twin_hops', String(hops + 1)); } catch (e) {}
        if (window.fgTrack) window.fgTrack({ type: 'autoroute', label: 'twin:' + tw.cc + '>' + mine, path: (location.pathname || '').slice(0, 200), productHandle: tw.handle });
        /* The flag BEFORE the verdict: fg-analytics sends the held pageview inside the
           fg:twinroute event, and only this flag drops it. In the other order every
           switch counted the page it left (measured live 2026-10-02). */
        window.__fgRedirecting = true;   // fg-analytics: not a real view of the store we are leaving
        twinVerdict('routed');           // the held entry pageview is now dropped, not delayed
        location.replace((tw.lp || '') + '/products/' + twin);
        return;
      }
      showNotHere(mine);
    }

    /* A visitor from a country we do NOT sell in. We never switch them (there is
       no store to switch to) and we never hide the price — owner 2026-09-08:
       "if we hide the prices and we still have mismatch countries, we would lose
       the price on the right". A wrong location guess must cost a label, not a
       price. So the price stays exactly as it is and gains one line saying which
       country it belongs to, which is the thing the customer could not tell.

       Measured 2026-09-08: 100 of the 104 wrong-store product views were these
       visitors — the United States, Turkey, France, Bangladesh, Libya — seeing a
       UAE or Lebanon price with nothing to name it. */
    function labelPrice() {
      twinVerdict('stay');   // they stay here; this IS a real view
      var ar = twinAr();
      var here = COUNTRIES[tw.cc];
      if (!here) return next();
      function bare(s) { return String(s).replace(/^the /, ''); }
      var name = ar ? here.label : bare(EN_NAMES[tw.cc] || here.label);
      var text = ar ? ('سعر ' + name) : (name + ' price');
      var tries = 0;
      /* The three selectors above are ALL Debutify's, and only the UAE templates
         carry its price block: counted at 2026-09-08, `"type": "_product_price"`
         is in 281 of 281 uae templates and 0 of the 136 lebanon / 19 iraq /
         11 jordan / 1 egypt ones. Those print the price from a plain text block
         — `Price: <strong>{{ custom_price_<cc> }}</strong>` — with no class of
         its own, so without this the label silently never attached on 167
         product pages, which is most of what a shared link points at. Matched on
         the visible wording rather than a class because the templates give it
         none; the wording is the same word the page shows in either language. */
      function countryPriceLine() {
        /* Arm B of the first-screen test (fg-product-mobile) moved that text block into
           .fg-pm-head above the gallery as .fg-pm-price on 2026-10-23 only; since 2026-10-24
           it stays in place, this lookup finds nothing and the search below finds it. */
        var moved = document.querySelector('.fg-pm-head .fg-pm-price');
        if (moved && moved.querySelector('strong')) return moved;
        var scope = document.querySelector('.product__info-container') || document;
        var ps = scope.querySelectorAll('p.product__text, .product__text');
        for (var i = 0; i < ps.length; i++) {
          if (!ps[i].querySelector('strong')) continue;
          var t = (ps[i].textContent || '').replace(/\s+/g, ' ').trim();
          if (/^(price|السعر|سعر)\s*[:：]/i.test(t)) return ps[i];
        }
        return null;
      }
      (function attach() {
        if (document.querySelector('.fg-pricecc')) return;
        /* The PDP price, in the order fg-row-price-gate lists them: the fg skin's
           own price first, then Debutify's inside the product info column.
           `.price` alone is not safe — it is on tiles too. */
        /* On a computer the RedMagic-style section (fg-pdp-buybox) hides the price line and
           shows `.fg-pdx-price` instead, so that one is labelled when it is there. */
        var el = document.querySelector('.fg-pdx-price')
              || document.querySelector('.fg-pd__price')
              || document.querySelector('.product__info-container .price')
              || document.querySelector('.price__container')
              || countryPriceLine();
        var shown = el && (el.offsetWidth > 0 || el.offsetHeight > 0);
        if (!shown) {
          /* Either the price has not rendered yet, or this browser saved
             "worldwide" and the price gate has hidden it — in which case there
             is nothing to label and we stop asking. */
          if (++tries < 4) return setTimeout(attach, 400);
          return;
        }
        var tag = document.createElement('span');
        tag.className = 'fg-pricecc';
        tag.setAttribute('data-fg-scope', 'price-country');
        tag.textContent = text;
        el.insertAdjacentElement('afterend', tag);
        /* The phone buy box (fg-product-mobile, arm B) prints the same figure again above
           the nav; it gets the same label, or that copy is the unlabelled price this
           function exists to end. */
        var boxLine = document.querySelector('[data-fg-atc-price] .fg-pm-atc__now');
        if (boxLine) boxLine.parentNode.appendChild(tag.cloneNode(true));
        try {
          if (!sessionStorage.getItem('fg_pricecc_logged')) {
            sessionStorage.setItem('fg_pricecc_logged', '1');
            if (window.fgTrack) window.fgTrack({ type: 'autoroute', label: 'pricelabel:' + tw.cc, path: (location.pathname || '').slice(0, 200), productHandle: tw.handle });
          }
        } catch (e) {}
      })();
    }

    /* No twin: tell them plainly, offer their own store, and let them stay. */
    function showNotHere(mine) {
      twinVerdict('stay');   // they stay here; this IS a real view
      if (document.getElementById('fg-geonudge') || document.getElementById('fg-twinbar')) return next();
      var ar = twinAr();
      var mineInfo = COUNTRIES[mine], hereInfo = COUNTRIES[tw.cc];
      if (!mineInfo || !hereInfo) return next();
      function bare(s) { return String(s).replace(/^the /, ''); }
      var mineName = ar ? mineInfo.label : (EN_NAMES[mine] || mineInfo.label);
      var hereName = ar ? hereInfo.label : (EN_NAMES[tw.cc] || hereInfo.label);
      if (window.fgTrack) window.fgTrack({ type: 'autoroute', label: 'twinmiss:' + tw.cc + '>' + mine, path: (location.pathname || '').slice(0, 200), productHandle: tw.handle });
      var el = document.createElement('div');
      el.id = 'fg-twinbar';
      el.className = 'fg-artoast fg-artoast--prompt';
      el.setAttribute('role', 'status');
      el.setAttribute('data-fg-scope', 'twin-bar');
      el.innerHTML =
        '<span class="fg-artoast__flag" aria-hidden="true">' + hereInfo.flag + '</span>' +
        '<span class="fg-artoast__txt">' +
          '<b class="fg-artoast__title">' + (ar ? ('هذا المنتج من متجر ' + hereName) : ('This product is from the ' + bare(hereName) + ' store')) + '</b>' +
          '<span class="fg-artoast__sub">' + (ar ? ('وهو غير متوفر في متجر ' + mineName) : ("It isn't sold in " + mineName + ' — prices here are ' + bare(hereName) + ' prices')) + '</span>' +
        '</span>' +
        '<button type="button" class="fg-artoast__btn" data-track="fg-twinbar-switch">' + (ar ? ('تصفح متجر ' + mineName) : ('Browse ' + mineName)) + '</button>' +
        '<button type="button" class="fg-artoast__x" data-track="fg-twinbar-stay" aria-label="' + (ar ? 'عرضه على أي حال' : 'See it anyway') + '">&times;</button>';
      document.body.appendChild(el);
      requestAnimationFrame(function () { el.classList.add('is-in'); });
      el.querySelector('.fg-artoast__btn').addEventListener('click', function () { window.chooseCountry(mine); });
      el.querySelector('.fg-artoast__x').addEventListener('click', function () {
        rememberKeep();                    // stay on this page, and stop asking
        el.classList.remove('is-in');
        setTimeout(function () { if (el.parentNode) el.parentNode.removeChild(el); }, 300);
      });
    }
  }

  /* Arriving on the twin we switched them to: say so, and offer the page they
     actually tapped — ?fgtwin=0 keeps that link from bouncing straight back. */
  function maybeShowTwinToast() {
    try {
      var from = sessionStorage.getItem('fg_twin_from');
      if (!from) return;
      sessionStorage.removeItem('fg_twin_from');
      var bits = from.split('|'), fromCc = bits[0], fromHandle = bits[1];
      var info = COUNTRIES[fromCc];
      if (!info || !window.fgTwins) return;
      var ar = twinAr(), lp = (window.fgTwins.lp || '');
      var hereInfo = COUNTRIES[window.fgTwins.cc];
      var hereName = hereInfo ? (ar ? hereInfo.label : (EN_NAMES[window.fgTwins.cc] || hereInfo.label)) : '';
      var fromName = ar ? info.label : (EN_NAMES[fromCc] || info.label);
      function bare(s) { return String(s).replace(/^the /, ''); }
      var el = document.createElement('div');
      el.id = 'fg-twintoast';
      el.className = 'fg-artoast fg-artoast--prompt';
      el.setAttribute('role', 'status');
      el.setAttribute('data-fg-scope', 'twin-toast');
      el.innerHTML =
        '<span class="fg-artoast__flag" aria-hidden="true">' + (hereInfo ? hereInfo.flag : '') + '</span>' +
        '<span class="fg-artoast__txt">' +
          '<b class="fg-artoast__title">' + (ar ? ('هذه نسخة متجر ' + hereName) : ('Showing the ' + bare(hereName) + ' version')) + '</b>' +
          '<span class="fg-artoast__sub">' + (ar ? ('الرابط كان من متجر ' + fromName) : ('Your link was from ' + fromName + ' — these are your prices')) + '</span>' +
        '</span>' +
        '<a class="fg-artoast__btn" data-track="fg-twintoast-original" href="' + lp + '/products/' + fromHandle + '?fgtwin=0">' + (ar ? 'عرض الرابط الأصلي' : 'Open the original') + '</a>' +
        '<button type="button" class="fg-artoast__x" data-track="fg-twintoast-dismiss" aria-label="' + (ar ? 'إغلاق' : 'Dismiss') + '">&times;</button>';
      document.body.appendChild(el);
      requestAnimationFrame(function () { el.classList.add('is-in'); });
      var t = setTimeout(close, 9000);
      el.querySelector('.fg-artoast__x').addEventListener('click', function () { clearTimeout(t); close(); });
      function close() { el.classList.remove('is-in'); setTimeout(function () { if (el.parentNode) el.parentNode.removeChild(el); }, 300); }
    } catch (e) {}
  }

  function maybeShowGeoNudge() {
    try {
      if (window.fgTwins && window.fgTwins.cc) return; // product pages: maybeSwitchProductCountry owns this
      if (window.top !== window.self) return;
      if (window.Shopify && window.Shopify.designMode) return;
      var host = (location.hostname || '').toLowerCase();
      if (host.includes('flarenio.com') || host.indexOf('myshopify.com') !== -1) return;
      if (window.__fgRedirecting || window.__fgGeoRoute === 'pending') return; // a redirect may be about to move them
      if (sessionStorage.getItem('fg_nudge_shown')) return; // switched or dismissed this session
      var saved = null;
      try { saved = localStorage.getItem('selectedCountry'); } catch (e) {}
      var pageCc  = (window.fgPage && window.fgPage.country) || '';
      var current = pageCc || saved;      // which store they are looking at
      if (!current) return;               // neutral page + nothing saved → nothing to compare
      if (document.getElementById('fg-autoroute-toast') || document.getElementById('fg-geonudge')) return;
      if (document.documentElement.classList.contains('popup-open')) return; // the selector is already asking
      detectCountry(function (iso) {
        var geoCode = iso && GEO_TO_CODE[String(iso).toUpperCase()];
        if (!geoCode || geoCode === current) return;
        var info = COUNTRIES[geoCode];
        if (!info) return;
        if (document.documentElement.classList.contains('popup-open')) return; // opened while geo resolved
        if (document.getElementById('fg-geonudge')) return;

        /* Move them, unless this is a product page or we already moved this
           browser once. chooseCountry saves the country and lands on that
           store; fg_autoroute makes the arrival toast greet them there. */
        /* template is the FULL name — "product.uae-cooler", not "product" */
        var isProduct = /^product($|\.)/.test(String((window.fgPage && window.fgPage.template) || ''));
        /* A creator link-in-bio page (page.creator-links) is an ENTRY page the
           visitor tapped on purpose, exactly like a product link from
           Instagram — never hijack it (its country resolves '' today, so this
           is belt-and-braces against a future resolver change). */
        var isCreator = isCreatorPage();
        var moved = null;
        try { moved = localStorage.getItem('fg_geo_moved'); } catch (e) {}
        /* pageCc must be real: on a neutral page (cart, search, 404) we only
           inferred the store from what they once saved — not solid enough to
           move them, and it would throw away the cart/search they are using. */
        if (pageCc && !isProduct && !isCreator && !moved) {
          try { localStorage.setItem('fg_geo_moved', '1'); } catch (e) {}
          try { sessionStorage.setItem('fg_nudge_shown', '1'); } catch (e) {}
          try { sessionStorage.setItem('fg_autoroute', geoCode); } catch (e) {}
          if (window.fgTrack) window.fgTrack({ type: 'autoroute', label: 'moved:' + current + '>' + geoCode, path: (location.pathname || '').slice(0, 200) });
          window.__fgRedirecting = true;   // fg-analytics: no phantom pageview of the store we are leaving
          window.chooseCountry(geoCode);
          return;
        }

        /* one analytics row per session, however many pages the bar rides */
        var logged = null;
        try { logged = sessionStorage.getItem('fg_nudge_logged'); } catch (e) {}
        if (!logged) {
          try { sessionStorage.setItem('fg_nudge_logged', '1'); } catch (e) {}
          if (window.fgTrack) window.fgTrack({ type: 'autoroute', label: 'nudge:' + current + '>' + geoCode, path: (location.pathname || '').slice(0, 200) });
        }

        var ar      = isAr();
        var geoName = ar ? info.label : (EN_NAMES[geoCode] || info.label);
        /* EN store names read mid-sentence ("the UAE") — the title slot already
           says "the", so strip a leading article to avoid "the the UAE store". */
        function cap(s) { return s.charAt(0).toUpperCase() + s.slice(1); }
        function bare(s) { return s.replace(/^the /, ''); }
        var curInfo = COUNTRIES[current];
        var title, sub;
        if (current === 'row') {
          title = ar ? 'أنت تتصفح المتجر العالمي' : "You're browsing the worldwide store";
        } else if (curInfo) {
          var curName = ar ? curInfo.label : (EN_NAMES[current] || curInfo.label);
          title = ar ? ('أنت تتصفح متجر ' + curName) : ('This is the ' + bare(curName) + ' store');
        } else {
          title = ar ? 'يبدو أنك في المتجر الخطأ' : 'You seem to be on the wrong store';
        }
        sub = ar
          ? ('يبدو أنك في ' + geoName + ' — الأسعار والتوصيل الخاصة بك هناك')
          : ("Looks like you're in " + cap(geoName) + ' — your prices & delivery are there');

        var el = document.createElement('div');
        el.id = 'fg-geonudge';
        el.className = 'fg-artoast fg-artoast--prompt';
        el.setAttribute('role', 'status');
        el.innerHTML =
          '<span class="fg-artoast__flag" aria-hidden="true">' + info.flag + '</span>' +
          '<span class="fg-artoast__txt">' +
            '<b class="fg-artoast__title">' + title + '</b>' +
            '<span class="fg-artoast__sub">' + sub + '</span>' +
          '</span>' +
          '<button type="button" class="fg-artoast__btn" data-track="fg-geonudge-switch">' + (ar ? 'انتقل إلى متجر ' + geoName : 'Go to ' + cap(geoName)) + '</button>' +
          '<button type="button" class="fg-artoast__x" data-track="fg-geonudge-dismiss" aria-label="' + (ar ? 'إغلاق' : 'Dismiss') + '">&times;</button>';
        document.body.appendChild(el);
        requestAnimationFrame(function () { el.classList.add('is-in'); });
        var gone = false;
        function dismiss() {
          if (gone) return;
          gone = true;
          el.classList.remove('is-in');
          setTimeout(function () { if (el.parentNode) el.parentNode.removeChild(el); }, 400);
        }
        el.querySelector('.fg-artoast__btn').addEventListener('click', function () {
          try { sessionStorage.setItem('fg_nudge_shown', '1'); } catch (e) {}
          dismiss();
          window.chooseCountry(geoCode); // saves the country + lands on its store
        });
        el.querySelector('.fg-artoast__x').addEventListener('click', function () {
          try { sessionStorage.setItem('fg_nudge_shown', '1'); } catch (e) {} // their call — quiet for the session
          dismiss();
        });
        /* no auto-dismiss: the bar stays until the visitor decides */
      });
    } catch (e) {}
  }

  /* First-visit geo verdict from the head script. 'routed' = a redirect is
     already committing — keep the page hidden and do nothing. Otherwise reveal
     the page and re-run the gate: geo failed / no store for that country → the
     selector opens exactly as before; Iraq detected → the country is now saved,
     so the popup skips and only the toast shows (home IS the Iraq store). */
  document.addEventListener('fg:georoute', function (e) {
    if (e && e.detail === 'routed') return;
    document.documentElement.classList.remove('fg-hide-body');
    document.documentElement.style.background = '';
    /* The verdict can arrive while the head is still parsing, before <body> exists: a
       "stay" on the root home (the worldwide store since 2026-10-10) threw "Cannot read
       properties of null (reading 'appendChild')" in mountSwitcher on live, whose fallback
       is document.body. The page work waits for the DOM. */
    function settle() {
      showPopupIfNoCountry();
      mountSwitcher();
      applyCountryNav();
      updateCartVisibility();
      maybeShowAutoRouteToast();
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', settle);
    else settle();
  });

  /* ---------- Init & safety ---------- */
  function init() {
    /* A tap the stub in snippets/country-popup.liquid answered while this file
       was still loading (the selector is visible before its script on slow
       phones): finish that choice first — the real chooseCountry closes the
       popup and navigates, and nothing else in init matters on a page we are
       leaving. */
    var pending = window.__fgPendingCountry;
    if (pending) { window.__fgPendingCountry = null; window.chooseCountry(pending); return; }
    redirectHomeToCountryPage(); // must run first — bails out if redirect fires
    showPopupIfNoCountry();
    mountSwitcher();
    applyCountryNav();
    updateCartVisibility();
    maybeShowAutoRouteToast();
    maybeShowTwinToast();
    maybeSwitchProductCountry(maybeShowGeoNudge);
    window.FG_NAV_REFRESH      = applyCountryNav;
    window.FG_SWITCHER_REFRESH = mountSwitcher;
    /* Ensure body is always revealed after init (covers sa, row, and all
       non-home pages) — EXCEPT while the head geo lookup is deciding
       ('pending': the fg:georoute handler above reveals when it settles) or a
       geo redirect is committing ('routed': never flash the wrong store during
       the swap). The head hide-script's own 2.5s timer stays the safety net. */
    var g = window.__fgGeoRoute;
    if (g !== 'pending' && g !== 'routed') {
      document.documentElement.classList.remove('fg-hide-body');
      document.documentElement.style.background = '';
    }
  }

  /* Deferred scripts run with DOM already parsed — don't wait for DOMContentLoaded */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('page:load', init);
  document.addEventListener('shopify:section:load', init);

  window.addEventListener('beforeunload', hidePopup);
  window.addEventListener('pagehide', hidePopup);
})();


/* ===== Make "المتجر" and "طريقك للاحتراف" open popup or route by saved country ===== */
(function attachCountryAwareCTAs(){
  // map saved country → destination
  function goToCountryPage(code) {
    var lp = (window.FG_LANG && window.FG_LANG.get() === 'ar') ? '/ar' : '';
    switch (code) {
      case 'uae': window.location.href = lp + '/pages/uae-collections'; break;
      case 'bh':  window.location.href = lp + '/pages/bh-b'; break;
      case 'kw':  window.location.href = lp + '/pages/kw-b'; break;
      case 'qa':  window.location.href = lp + '/pages/qa-b'; break;
      case 'om':  window.location.href = lp + '/pages/om-b'; break;
      case 'lb':  window.location.href = lp + '/pages/lebanon-collections'; break;
      case 'jo':  window.location.href = lp + '/pages/jordan-collections'; break;
      case 'iq':  window.location.href = lp + '/pages/iraq-collections'; break;
      case 'eg':  window.location.href = lp + '/pages/egypt'; break;
      case 'row':
      default:
        window.location.href = 'https://api.whatsapp.com/send/?phone=971543537768&text=Hi%2C+I%27m+interested+in+your+products+on+FlaregunTV&type=phone_number&app_absent=0';
    }
  }

  function openCountryPopup() {
    if (typeof showPopup === 'function') return showPopup();
    var el = document.getElementById('country-popup');
    if (el) el.style.display = 'flex';
  }

  function handleClick(e) {
    e.preventDefault();
    var selected = localStorage.getItem('selectedCountry');
    if (selected) {
      goToCountryPage(selected);
    } else {
      openCountryPopup();
    }
  }

  // labels to bind (Arabic + English, since templates may render either)
  var labels = ['المتجر', 'طريقك للاحتراف', 'Shop', 'Your Path to Pro'];

  function bindLinks(root) {
    (root || document).querySelectorAll('a').forEach(function(a){
      // Never hijack the custom header's own nav — the Arabic "Store" dropdown
      // button is labelled "المتجر" and this binding was force-navigating it
      // instead of letting its dropdown open.
      if (a.closest && a.closest('.fg-aheader')) return;
      var txt = (a.textContent || '').trim();
      if (labels.includes(txt) && !a.dataset.countryAwareCta) {
        a.dataset.countryAwareCta = '1';
        a.style.cursor = 'pointer';
        a.addEventListener('click', handleClick);
      }
    });
  }

  // initial + dynamic binds (Debutify sections/AJAX)
  document.addEventListener('DOMContentLoaded', function(){ bindLinks(document); });
  document.addEventListener('page:load', function(){ bindLinks(document); });
  document.addEventListener('shopify:section:load', function(e){ bindLinks(e && e.target ? e.target : document); });

  var mo = new MutationObserver(function(muts){
    muts.forEach(function(m){
      if (m.addedNodes && m.addedNodes.length) {
        m.addedNodes.forEach(function(n){
          if (n.nodeType === 1) bindLinks(n);
        });
      }
    });
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
